// // src/embed.js
// import React from "react";
// import ReactDOM from "react-dom";
// // import 'https://bot.coolbiz.info/static/css/style.css'
// import LiveChat from "../components/live-chat/LiveChat";
// import { BrowserRouter } from "react-router-dom";
// // This will be used to embed the chatbot into the host page
// const initChatbot = () => {
//   console.log("Chatbot embed script loaded");
//   const chatbotContainer = document.createElement("div");
//   chatbotContainer.id = "chatbot-container";
//   document.body.appendChild(chatbotContainer);

//   ReactDOM.render(
//     <BrowserRouter>
//       <LiveChat connectionType={"outside"} />
//     </BrowserRouter>,
//     chatbotContainer,
//   );
// };

// // Wait for the script to load, then initialize the chatbot
// window.onload = initChatbot;
import React from "react";
import ReactDOM from "react-dom/client";

import BotEmbed from "../components/BotEmbed";

const getBotIdFromScript = () => {
  const scriptElement =
    document.currentScript ||
    Array.from(document.querySelectorAll("script")).find((script) =>
      script.src.includes("/embed/chatbot.js"),
    );

  if (!scriptElement?.src) {
    return "";
  }

  try {
    const scriptUrl = new URL(scriptElement.src, window.location.href);
    return scriptUrl.searchParams.get("id") || "";
  } catch (error) {
    return "";
  }
};

const scriptBotId = getBotIdFromScript();

const initChatbot = () => {
  if (document.getElementById("chatbot-container")) return;

  const chatbotContainer = document.createElement("div");
  chatbotContainer.id = "chatbot-container";
  document.body.appendChild(chatbotContainer);

  const shadowRoot = chatbotContainer.attachShadow({ mode: "open" });
  const muiPortalContainer = document.createElement("div");
  const mountNode = document.createElement("div");
  shadowRoot.appendChild(muiPortalContainer);
  shadowRoot.appendChild(mountNode);

  const root = ReactDOM.createRoot(mountNode);
  root.render(
    <BotEmbed
      botId={scriptBotId}
      mode="embed"
      muiPortalContainer={muiPortalContainer}
      shadowRoot={shadowRoot}
    />,
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initChatbot);
} else {
  initChatbot();
}
